import React, { useState } from 'react';
import { ShoppingBagIcon, ShirtIcon, HomeIcon, UsersIcon } from 'lucide-react';
import Button from './Button';
import Wizard from './Wizard';
import { useTranslation } from '../i18n/useTranslation';
const Solutions = () => {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const {
    t
  } = useTranslation();
  return <section id="solutions" className="py-16 bg-white" data-id="element-2155">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2156">
        <div className="text-center mb-12" data-id="element-2157">
          <h2 className="text-3xl font-bold mb-4" data-id="element-2158">
            {t('sections.solutions.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-2159">
            {t('sections.solutions.subtitle')}
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-2160">
          <div className="bg-white rounded-xl p-6 shadow-card border border-gray-100" data-id="element-2161">
            <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-2162">
              <ShoppingBagIcon className="h-8 w-8 text-primary" data-id="element-2163" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-2164">
              {t('sections.solutions.electronics.title')}
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-2165">
              {t('sections.solutions.electronics.description')}
            </p>
            <ul className="space-y-2 mb-6" data-id="element-2166">
              {t('sections.solutions.electronics.items', {
              returnObjects: true
            }).map((item, index) => <li key={index} className="text-gray-600 text-sm" data-id="element-2167">
                  • {item}
                </li>)}
            </ul>
            <Button variant="outline" fullWidth onClick={() => setIsWizardOpen(true)} data-id="element-2168">
              {t('buttons.learnMore')}
            </Button>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-card border border-gray-100" data-id="element-2169">
            <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-2170">
              <ShirtIcon className="h-8 w-8 text-primary" data-id="element-2171" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-2172">
              {t('sections.solutions.fashion.title')}
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-2173">
              {t('sections.solutions.fashion.description')}
            </p>
            <ul className="space-y-2 mb-6" data-id="element-2174">
              {t('sections.solutions.fashion.items', {
              returnObjects: true
            }).map((item, index) => <li key={index} className="text-gray-600 text-sm" data-id="element-2175">
                  • {item}
                </li>)}
            </ul>
            <Button variant="outline" fullWidth onClick={() => setIsWizardOpen(true)} data-id="element-2176">
              {t('buttons.learnMore')}
            </Button>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-card border border-gray-100" data-id="element-2177">
            <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-2178">
              <HomeIcon className="h-8 w-8 text-primary" data-id="element-2179" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-2180">
              {t('sections.solutions.home.title')}
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-2181">
              {t('sections.solutions.home.description')}
            </p>
            <ul className="space-y-2 mb-6" data-id="element-2182">
              {t('sections.solutions.home.items', {
              returnObjects: true
            }).map((item, index) => <li key={index} className="text-gray-600 text-sm" data-id="element-2183">
                  • {item}
                </li>)}
            </ul>
            <Button variant="outline" fullWidth onClick={() => setIsWizardOpen(true)} data-id="element-2184">
              {t('buttons.learnMore')}
            </Button>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-card border border-gray-100" data-id="element-2185">
            <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-2186">
              <UsersIcon className="h-8 w-8 text-primary" data-id="element-2187" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-2188">
              {t('sections.solutions.agency.title')}
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-2189">
              {t('sections.solutions.agency.description')}
            </p>
            <ul className="space-y-2 mb-6" data-id="element-2190">
              {t('sections.solutions.agency.items', {
              returnObjects: true
            }).map((item, index) => <li key={index} className="text-gray-600 text-sm" data-id="element-2191">
                  • {item}
                </li>)}
            </ul>
            <Button variant="outline" fullWidth onClick={() => setIsWizardOpen(true)} data-id="element-2192">
              {t('buttons.learnMore')}
            </Button>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-2193">
          <Button variant="primary" size="lg" onClick={() => setIsWizardOpen(true)} data-id="element-2194">
            {t('buttons.findSolution')}
          </Button>
        </div>
      </div>
      <Wizard isOpen={isWizardOpen} onClose={() => setIsWizardOpen(false)} data-id="element-2195" />
    </section>;
};
export default Solutions;